import React from 'react';
import './UnderConstruction.css'; // Stil dosyasını ayrı tutmak istersen

const UnderConstruction = () => {
    return (
        <div className="construction-container">
            <h1>🚧 Sayfa Yapım Aşamasında</h1>
            <p>Bu sayfa şu anda geliştiriliyor. Lütfen daha sonra tekrar kontrol edin.</p>
            {/*<div className="loader"></div>*/}
        </div>
    );
};

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/common/UnderConstruction.js